<script>
import axios from 'axios';
import truncate from 'truncate';
import Paginate from 'vuejs-paginate-next';

export default {
    props: {
        labels: String,
        years: String,
        lang: String,
    },
    mounted() {
        this.parsedLabels = JSON.parse(this.labels);
        this.parsedYears = JSON.parse(this.years);
        this.axiosParams.lang = this.lang;

        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.has('y')) {
            this.showFilter = true;
            const year = urlParams.get('y');
            this.axiosParams.after = year;
        }

        this.getPaginationInfo();
    },
    data() {
        return {
            axiosUrl: '/wp-json/wp/v2/report',
            axiosParams: {
                per_page: 6,
                page: 1,
                search: '',
                after: '',
                lang: ''
            },
            posts: [],
            pageCount: 1,
            showFilter: false,
            parsedLabels: [],
            loading: false,
            total: 0,
        };
    },
    components: {
        paginate: Paginate,
    },
    watch: {
        'axiosParams.page'(newValue, oldValue) {
            if (newValue != oldValue) {
                this.getPosts();
            }
        },
        'axiosParams.after'(newValue, oldValue) {
            if (newValue != oldValue) {
                this.resetAxiosParams();
                this.getPosts();
            }
        },
    },
    methods: {
        getPaginationInfo() {
            let params = Object.assign({}, this.axiosParams);

            if (params.after === '') {
                delete params.after;
            }

            axios
                .get(this.axiosUrl, { params: params })
                .then((response) => {
                    this.configPagination(response.headers);
                })
        },
        getPosts() {
            this.loading = true;

            let params = Object.assign({}, this.axiosParams);

            if (params.after === '') {
                delete params.after;
            } else {
                const before = (+params.after + 1).toString();
                params.after = new Date(params.after).toISOString();
                params.before = new Date(before).toISOString();
            }

            axios
                .get(this.axiosUrl, { params: params })
                .then((response) => {
                    this.posts = response.data;
                    this.configPagination(response.headers);
                    setTimeout(() => {
                        this.loading = false;
                        window.scrollTo(0, 0);
                    }, 1000);
                    this.updateUrlParams();
                })
        },
        truncateString(string, limit) {
            return truncate(string, limit);
        },
        doPagination(page) {
            this.axiosParams.page = page;
        },
        configPagination(headers) {
            this.pageCount = +headers['x-wp-totalpages'];
        },
        resetAxiosParams() {
            this.axiosParams.page = 1;
        },
        updateUrlParams() {
            const urlParams = new URLSearchParams(window.location.search);

            if (this.axiosParams.hasOwnProperty('after')) {
                if (this.axiosParams.after !== '') {
                    urlParams.set('y', this.axiosParams.after);
                } else {
                    urlParams.delete('y');
                }
            }

            window.history.pushState('', '', '?' + urlParams.toString());
        }
    },
};
</script>

<template>
    <!-- <form class="form wrapper">
        <fieldset>
            <label for="year">{{ parsedLabels.year }}</label>
            <select id="year" class="form__select" v-model="axiosParams.after">
                <option value>{{ parsedLabels.all_years }}</option>
                <option v-for="item in parsedYears" :value="item" :key="item">{{ item }}</option>
            </select>
        </fieldset>
    </form> -->
    <div id="report-list" class="wrapper">
        <div v-if="loading" class="press__loader">
            <div class="loader"></div>
        </div>
        <div v-if="!loading">
            <ul class="press__list">
                <slot v-if="axiosParams.page === 1 && axiosParams.after === ''"></slot>
                <li v-else class="report-item" v-for="item in posts" :key="item.id">
                    <p class="report-item__date date">{{parsedLabels.report}} · {{item.custom_date}}</p>
                    <h3 class="report-item__title h3"
                        v-html="item.title.rendered"></h3>
                    <a class="report-item__link" :href=item.report.url>{{parsedLabels.read_more}}</a>
                </li>
            </ul>
            <p v-if="axiosParams.page !== 1 && posts.length === 0">{{ parsedLabels.no_result }}</p>
        </div>
        <paginate v-if="pageCount > 1" :force-page="axiosParams.page" :page-count="pageCount" :page-range="3" :margin-pages="1"
            :click-handler="doPagination" :prev-text="''" :next-text="''" :container-class="'pagination'"
            :page-class="'pagination__item'" :page-link-class="'pagination__item-link'"
            :next-class="'pagination__item pagination__item--next'" :prev-class="'pagination__item pagination__item--prev'"
            :disabled-class="'disabled'"></paginate>
    </div>
</template>

<style lang="scss" scoped>
.press {
    &__result-label {
        padding-bottom: 32px;
    }

    &__loader {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 25vh;
    }
}
.form {
    margin-top: 36px;
    margin-bottom: 38px;

    @media #{$mediaMd} {
        margin-top: 56px;
    }

    fieldset {
        margin-bottom: 8px;
    }

    label {
        display: block;
        font-weight: 700;
        margin-bottom: 16px;
    }

    select {
        display: block;
        appearance: none;
        -webkit-appearance: none;
        border: 1px solid $black-800;
        color: $black-800;
        padding: 0 24px;
        border-radius: 100vmax;
        min-width: 300px;
        height: 40px;
        margin: 0;
        font-size: 1.6rem;
        background-image: url('#{$assetsPath}/images/select-black.svg');
        background-repeat: no-repeat;
        background-position: center right 16px;
        background-color: transparent;
        outline: none;
        cursor: pointer;

        &::-ms-expand {
            display: none;
        }
    }
}
</style>
